import { Button } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { HttpClientError } from "../../../providers/HttpClient";
import useToggleBulkAssigneeTagApiService from "../services/api/ToggleBulkAssigneeTagApiService";
import TagAssignee from "../services/model/TagAssignee";
import { queryClient } from "../../../App";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type TagAddSelectedEmployeesButtonProps = {
  assignee: TagAssignee[];
  selectedEmployees: { id: number }[];
  id: number;
  onSuccess: () => void;
};

type TagEmployeeFormData = {
  untag: number[];
  tag: number[];
};

const TagAddSelectedEmployeesButton: React.FC<
  TagAddSelectedEmployeesButtonProps
> = ({ assignee, selectedEmployees, id, onSuccess }) => {
  const { showToast } = useToasts();
  const sortFormData = (): TagEmployeeFormData => {
    const tag = selectedEmployees ? selectedEmployees.map((it) => it.id) : [];
    return {
      untag: assignee.filter((it) => !tag.includes(it.id)).map((it) => it.id),
      tag: tag.filter((it) => !assignee.map((d) => d.id).includes(it)),
    };
  };

  const [employees, setEmployees] = useState<TagEmployeeFormData>(() =>
    sortFormData()
  );

  useEffect(() => {
    setEmployees(sortFormData());
  }, [selectedEmployees]);

  const { isError, isSuccess, error, isLoading, mutateAsync } =
    useToggleBulkAssigneeTagApiService();

  const updateEmployeeTags = async (): Promise<void> => {
    const tagPromise = mutateAsync({
      tagId: id,
      employees: employees.tag,
      isTagged: true,
    });
    const unTagPromise = mutateAsync({
      tagId: id,
      employees: employees.untag,
      isTagged: false,
    });

    await Promise.all([tagPromise, unTagPromise]);
    onSuccess();
  };

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries(["TagsDetailsApiService", id]).then(() => {
        showToast({ strapiId: "selected_employees_tags_updated" });
        if (onSuccess) {
          onSuccess();
        }
      });
    } else if (isError) {
      showToast({
        strapiId: "selected_employees_tags_update_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isSuccess, isError]);

  return (
    <div className="p-4">
      <Button
        onClick={updateEmployeeTags}
        disabled={isLoading}
        fullWidth
        type="button"
        color="jem-theme"
        variant="filled"
      >
        Update Selected
      </Button>
    </div>
  );
};

export default TagAddSelectedEmployeesButton;
